/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { IconButton, TableBody, TableRow } from '@mui/material';
import CustomTableCell from 'components/cmn/CustomTableCell';
import { ICmnTableBodyProps } from 'interface/cmn/commonInfo';
import { SurveyListLatestContent } from 'interface/project/projectInfo';
import { getComparatorAny, stableSort } from 'libs/mindUtils';
import { useNavigate } from 'react-router-dom';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

function DiagnosticTableBody({ loading, rows }: ICmnTableBodyProps<SurveyListLatestContent>): JSX.Element {
  const navigate = useNavigate();
  const handleModfiy = (row: SurveyListLatestContent) => {
    navigate(`/admin/diagnostic-management/${row.id}`, {
      state: {
        dataInfo: row,
      },
    });
  };
  const handleConvertType = (_type: string): string => {
    const providerMap: { [key: string]: string } = {
      ID: '개별',
      ME: '다면',
      AD: '추가문항',
    };
    return providerMap[_type] ?? _type ?? '-';
  };

  return (
    <>
      {!loading && rows.length === 0 && (
        <TableBody>
          <TableRow>
            <CustomTableCell align="center" colSpan={5} sx={{ border: 'none' }}>
              조회된 데이터가 없습니다.
            </CustomTableCell>
          </TableRow>
        </TableBody>
      )}
      {!loading && rows.length !== 0 && (
        <TableBody>
          {stableSort(rows, getComparatorAny('desc', 'id')).map((row, index) => {
            const labelId = `table-checkbox-${index}`;
            return (
              <TableRow hover tabIndex={-1} key={row.id} id={labelId}>
                <CustomTableCell align="center">{row.surveyName}</CustomTableCell>
                <CustomTableCell align="center">{row.saveFileName}</CustomTableCell>
                <CustomTableCell align="center">{handleConvertType(row.surveyType)}</CustomTableCell>
                <CustomTableCell align="center">{row.updAt}</CustomTableCell>
                <CustomTableCell align="center">
                  <IconButton onClick={() => handleModfiy(row)} sx={{ width: 32 }}>
                    <SettingsOutlinedIcon />
                  </IconButton>
                </CustomTableCell>
              </TableRow>
            );
          })}
        </TableBody>
      )}
    </>
  );
}

export default memo(DiagnosticTableBody);
